export class NewquestionModel {
    id:number;
    sn:number;
    assessmentid_:number;
    text:string;
    marks_:string;
    batchid:number;
    optionsJSONString:string;
}

export class QuestionAnswer
   {
     assessmentID :number;
     questiontype : string;
     questionID : number;
     optionID : number;
     AnswerText : string;
     FileData : any;
    }

    export class QuestionDisplay{

      index:number = 0;
      next:number = 0;
      previous:number = 0;
      marks:number = 0;
      questionText:string ="";
      answeredText:string ="";
      questionId:number =0;

  }
